(function () {
  'use strict';
  var script = document.currentScript;
  if (!script || script.getAttribute('data-page-type') !== 'index' || window.__yousweetyP09CarouselA11y) return;
  window.__yousweetyP09CarouselA11y = true;
  var labelTemplate = script.getAttribute('data-slide-label') || '';
  var selector = '.slideshow, .grid-products.carousel, .grid--blog.carousel';
  var states = new Map();
  var widths = new WeakMap();
  var labels = new WeakMap();
  var resize = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!states.has(entry.target)) return;
      var width = entry.contentRect.width;
      if (!width || widths.get(entry.target) === width) return;
      widths.set(entry.target, width);
      var instance = window.Flickity && window.Flickity.data(entry.target);
      if (instance) instance.resize();
    });
  }) : null;

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function removeAttribute(element, name) {
    if (element.hasAttribute(name)) element.removeAttribute(name);
  }

  function validLabel(value) {
    return value && value.trim() && value !== 'null' && value !== 'undefined';
  }

  function unregister(root) {
    var state = states.get(root);
    if (!state) return;
    state.observer.disconnect();
    state.cells.forEach(function (value, cell) { cell.inert = value; });
    state.cells.clear();
    if (resize && root.matches('.slideshow')) resize.unobserve(root);
    widths.delete(root);
    states.delete(root);
  }

  function sync(root) {
    var state = states.get(root);
    if (!state) return;
    state.queued = false;
    if (!root.isConnected || !root.matches(selector)) {
      unregister(root);
      return;
    }
    if (!root.classList.contains('flickity-enabled')) {
      state.cells.forEach(function (value, cell) { cell.inert = value; });
      state.cells.clear();
      return;
    }
    var cells = new Set();
    root.querySelectorAll('.flickity-slider > *').forEach(function (cell) {
      if (cell.closest(selector) !== root) return;
      cells.add(cell);
      if (!state.cells.has(cell)) state.cells.set(cell, cell.hasAttribute('inert') || cell.inert === true);
      var inert = state.cells.get(cell) || cell.getAttribute('aria-hidden') === 'true';
      if (cell.inert !== inert) cell.inert = inert;
    });
    state.cells.forEach(function (value, cell) {
      if (!cells.has(cell)) {
        cell.inert = value;
        state.cells.delete(cell);
      }
    });
    if (!root.matches('.slideshow')) return;
    root.querySelectorAll('ol.flickity-page-dots').forEach(function (dots) {
      removeAttribute(dots, 'role');
      var items = dots.querySelectorAll('.dot');
      items.forEach(function (dot, index) {
        var button = dot.querySelector('button');
        var original = dot.getAttribute('aria-label');
        if (validLabel(original)) labels.set(dot, original);
        else if (!labels.has(dot) && button && validLabel(button.getAttribute('aria-label'))) labels.set(dot, button.getAttribute('aria-label'));
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.addEventListener('click', function (event) {
            event.stopPropagation();
            dot.click();
          });
          dot.appendChild(button);
        }
        var fallback = labelTemplate ? labelTemplate.replace('[number]', String(index + 1)).replace('[total]', String(items.length)) : String(index + 1) + ' / ' + String(items.length);
        setAttribute(button, 'aria-label', labels.get(dot) || fallback);
        setAttribute(button, 'aria-pressed', String(dot.classList.contains('is-selected')));
        removeAttribute(dot, 'role');
        removeAttribute(dot, 'tabindex');
        removeAttribute(dot, 'aria-label');
      });
    });
  }

  function schedule(root) {
    var state = states.get(root);
    if (!state || state.queued) return;
    state.queued = true;
    queueMicrotask(function () { sync(root); });
  }

  function register(root) {
    if (states.has(root) || !root.matches(selector)) return;
    var observer = new MutationObserver(function () { schedule(root); });
    states.set(root, { observer: observer, queued: false, cells: new Map() });
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    if (resize && root.matches('.slideshow')) resize.observe(root);
    sync(root);
  }

  function discover(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(selector)) register(node);
    node.querySelectorAll(selector).forEach(register);
  }

  function init() {
    var main = document.getElementById('PageContainer');
    if (!main) return;
    if (!document.getElementById('p09-carousel-controls-style')) {
      var style = document.createElement('style');
      style.id = 'p09-carousel-controls-style';
      style.textContent = '.slideshow.flickity-enabled .flickity-page-dots .dot{position:relative}.slideshow.flickity-enabled .flickity-page-dots .dot>button{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;border-radius:inherit;background:transparent;cursor:pointer}.slideshow.flickity-enabled .flickity-page-dots .dot>button:focus-visible{outline:2px solid currentColor;outline-offset:2px}';
      document.head.appendChild(style);
    }
    discover(main);
    new MutationObserver(function (records) {
      var removed = false;
      records.forEach(function (record) {
        var root = record.target.nodeType === 1 && record.target.closest(selector);
        if (root && main.contains(root)) register(root);
        record.addedNodes.forEach(discover);
        if (record.removedNodes.length) removed = true;
      });
      if (removed) states.forEach(function (state, root) {
        if (!root.isConnected || !main.contains(root)) unregister(root);
      });
    }).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { discover(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
